import React, { useEffect, useState } from 'react'
import { CModal, CModalBody, CModalFooter, CProgress, CProgressBar } from '@coreui/react'
import { raiseToast } from 'src/views/utils/helper'
let PROGRESS_CHECK = 25
const StopProgressModal = ({ name, liveStreamData, handleClose }) => {
  const [progress, setProgress] = useState(33)

  useEffect(() => {
    setTimeout(() => {
      if (PROGRESS_CHECK < 100) {
        raiseToast('error', 'Something went wrong please try again.')
        handleClose()
      }
      return
    }, 420000)

    setTimeout(() => {
      PROGRESS_CHECK = 66
      setProgress(66)
      return
    }, 20000)
  }, [])

  useEffect(() => {
    if (progress === 66 && liveStreamData?.server_data?.status !== 'LIVE') {
      PROGRESS_CHECK = 100
      setProgress(100)
      setTimeout(() => {
        handleClose()
        return
      }, 5000)
    }
  }, [progress, liveStreamData])

  return (
    <CModal size="lg" scrollable visible={true} alignment="center" className=" border-0">
      <div
        className="px-5 text-white w-100 d-flex align-items-center"
        style={{ height: '3.8vw', backgroundImage: 'linear-gradient(to bottom, #646464, #111)' }}
      >
        <p style={{ fontSize: '1.5625vw' }} className="mb-0 line-clamp-1">
          {`Stop Live Stream '${name}'`}
        </p>
      </div>
      <CModalBody className="px-5 py-4">
        <p style={{ fontSize: '14px' }}>
          {`OTTDock Live Studio is requesting to stop the live stream. This may take a few minutes.`}
        </p>
        <div
          className={`w-100 py-3 recording-progress-bar-main ${
            progress < 100 ? 'recording-progress-bar' : 'progress-bar-stop'
          } `}
        >
          <CProgress className="">
            <CProgressBar className="text-white text-left overflow-visible px-2" value={progress}>
              {progress === 33 ? ' Requesting ...' : ''}
              {progress === 66 ? ' Pausing ...' : ''}
              {progress === 100 ? ' Stream Stopped' : ''}
            </CProgressBar>
          </CProgress>
        </div>
      </CModalBody>
      <CModalFooter className={` border-0 `}></CModalFooter>
    </CModal>
  )
}

export default StopProgressModal
